import { inject, Injectable, signal } from "@angular/core";
import { AccGoalFormValues } from '@interfaces';
import { FuncService } from "../../../../../services";


@Injectable({ providedIn: 'root' })
export class GoalEditorDialogDataService {

	private func = inject(FuncService);
	public readonly accGoalFormValues = signal<AccGoalFormValues | undefined>(undefined);

	async getGoalFormValues(accGoalId: number) {
		const accGoalFormValues = await this.func.accGoal.getGoalFormValuesById({ accGoalId });
		this.accGoalFormValues.set(accGoalFormValues);
	}

	async addGoal(values: AccGoalFormValues) {
		return this.func.accGoal.addGoal(values);
	}

	async editGoal(accGoalId: number, values: AccGoalFormValues) {
		return this.func.accGoal.editGoal({ accGoalId, values });
	}
}